import { render } from "./Recovery.vue?vue&type=template&id=9c1fec98&scoped=true&lang=pug"
import script from "./Recovery.vue?vue&type=script&lang=js"
export * from "./Recovery.vue?vue&type=script&lang=js"

import "./Recovery.vue?vue&type=style&index=0&id=9c1fec98&scoped=true&lang=sass"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c1fec98"]])

export default __exports__